//--------------------------------------------
//
// Arm module
//
//--------------------------------------------
'use strict';


import THREE from 'three';
import q from 'q';
import constants from './constants';

const Arm = (options) => {
	
	const self = this;

	const deferred = q.defer();
	
	const geometrySrc = options.geometrySrc;
	const textureSrc = options.textureSrc;
	const bump = options.bumpSrc;
	const side = options.side;
	const loader = new THREE.JSONLoader();
	const textureLoader = new THREE.TextureLoader();

	const loaderScreen = document.getElementById('loader');

	let hand;


	loader.load(
		geometrySrc,
		(geometry) => {

			textureLoader.load(
				textureSrc,
				(texture) => {
					texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
					texture.repeat.set(1, 1);

					const material = new THREE.MeshPhongMaterial({
						map: texture,
						specular: 0x111111,
						shininess: 99,
						reflectivity: 10,
						bumpMap: textureLoader.load(bump)
					});

					hand = new THREE.Mesh(geometry, material);
						
						hand.position.set(0,0,-900);

						hand.rotation.y = constants.ARM_Y;
						hand.rotation.x = constants.ARM_X;
						hand.rotation.z = constants.ARM_Z;

					
					loaderScreen.remove();
					deferred.resolve(hand);
				}
			)
		}
	)


	return deferred.promise;

}


export default Arm;



